import script from "./WebSpace.vue?vue&type=script&setup=true&lang=js"
export * from "./WebSpace.vue?vue&type=script&setup=true&lang=js"

import "./WebSpace.vue?vue&type=style&index=0&id=bf696ab2&scoped=true&lang=scss"
import "./WebSpace.vue?vue&type=style&index=1&id=bf696ab2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf696ab2"]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QSpinnerIos from 'quasar/src/components/spinner/QSpinnerIos.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QImg,QBtn,QAvatar,QBadge,QIcon,QSeparator,QSpinnerIos,QTabPanels,QTabPanel});
